module.exports = __webpack_public_path__ + "static/stone_cursed-c78090f82176b9cd14d066cf8b472ece.png";